import axios from 'axios';

import type { Country } from '../interfaces';
import type { Environment } from '../interfaces/environment';
import { hostsConfig } from '../utils';

export default abstract class LocationDao {
  static async getCountryById(env: Environment, countryId: string) {
    const url = hostsConfig[env].locationServiceUrl;
    const { data } = await axios.get<Country>(`${url}/countries/${countryId}`);
    return data;
  }
  static async getCountries(env: Environment) {
    const url = hostsConfig[env].locationServiceUrl;
    const { data } = await axios.get<Country[]>(`${url}/countries`);
    return data;
  }
}
